import { useEffect, useState } from "react";
import ReactHtmlParser from "react-html-parser";
import API from "../../api/phx";
import { logModalAction } from "../Analytics/Universal/PageView/datalayer.functions.js";


export default function StandardTextParser( { standardTextLink }) {
  const [bodyText, setBodyText] = useState("");

  useEffect(() => {
    const getStandardText = (standardTextLink) => {
        API.get(`/text?types=${standardTextLink}`).then((result) => {
          const data = result.data.data;
          setBodyText(data[0].body)
        });
  }
    getStandardText(standardTextLink);
    logModalAction('Modal Open','Checkout',standardTextLink)
  }, [standardTextLink]);

  return (
    <>{ReactHtmlParser(bodyText)}</>
  );
}
